module.exports = __webpack_public_path__ + "b4e7b517a7e4e066307f8e63a0bee443.png";


//////////////////
// WEBPACK FOOTER
// ./src/favicon-48.png
// module id = 500
// module chunks = 0